import React from 'react';
import { ClockFilled, CloseCircleFilled, Icon, InformationFilled, TickCircleFilled, WarningFilled } from '../Icon';
export var notificationIcons = {
  error: function error() {
    return /*#__PURE__*/React.createElement(Icon, {
      component: CloseCircleFilled
    });
  },
  generic: function generic() {
    return /*#__PURE__*/React.createElement(Icon, {
      component: TickCircleFilled
    });
  },
  info: function info() {
    return /*#__PURE__*/React.createElement(Icon, {
      component: InformationFilled
    });
  },
  success: function success() {
    return /*#__PURE__*/React.createElement(Icon, {
      component: TickCircleFilled
    });
  },
  warning: function warning() {
    return /*#__PURE__*/React.createElement(Icon, {
      component: WarningFilled
    });
  },
  neutral: function neutral() {
    return /*#__PURE__*/React.createElement(Icon, {
      component: ClockFilled
    });
  }
};